<template>
  <div class="ms-page">
    <b-tabs card lazy v-model="activeTab">
      <b-tab title="ADD SALE / PROMO / CLEARANCE">
        <keep-alive><SalePage /></keep-alive>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SalePage from "@/components/Products/SalePage";

export default {
  name: "ManageSalePage",
  components: { SalePage },
  data() {
    return { activeTab: 0 };
  }
};
</script>

<style scoped>
.ms-page { padding: 8px; }
.ms-page >>> .nav-tabs { display: none; } /* single tab, no need for tab bar */
</style>


// WEBPACK FOOTER //
// src/components/Products/ManageSalePage.vue